import React, { useEffect, useState } from "react";
import { Modal, Descriptions, Button, Spin, message, Typography, Checkbox } from "antd";
import ApiService from "../Components/apiService";
import { BASE_URL } from "../Components/Constant";

const { Title } = Typography;

const CustomConnectorConfigDetail = ({ visible, onClose, configId, connectorId }) => {
  const [loading, setLoading] = useState(false);
  const [config, setConfig] = useState(null);
  const [testLoading, setTestLoading] = useState(false);
  const [testResult, setTestResult] = useState(null);
  const [redirectChecked, setRedirectChecked] = useState(false);

  // Fetch connector config details
  const fetchConfig = async () => {
    setLoading(true);
    try {
      const apiService = new ApiService(
        `${BASE_URL}/connector_configs/${configId}`,
        { "Content-Type": "application/json" },
        "GET"
      );
      const response = await apiService.makeCall();
      setConfig(response);
    } catch (err) {
      console.error("Error fetching config:", err);
      message.error("Failed to load connector config");
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    if (visible && configId) {
      fetchConfig();
      setTestResult(null); // reset when modal reopens
    }
  }, [visible, configId]);

  // Test connection
  const handleTestConnection = async () => {
    // Redirect flow first
    if (redirectChecked) {
      const clientId = config.query_params_template.client_id; // assuming client_id stored in body_template
      console.log('client id is ::',clientId);
      const authUrl = config.auth_url; // Auth URL from config
      // const redirectUri = encodeURIComponent("https://nucleus.mind-mesh.com/authenticate");
      const redirectUri = "https://nucleus.mind-mesh.com/authenticate";
      const state = configId; // pass connection id in state
      
      let redirect_uri = `${authUrl}?state=configId:${configId};connectorId:${connectorId}`;
      for (let key in config.query_params_template) {
        if (config.query_params_template.hasOwnProperty(key)) {
          const value = config.query_params_template[key];
          redirect_uri += `&${key}=${value}`;
        }
      }
      console.log('redirect_uri ::',redirect_uri);
      window.location.href = redirect_uri; // redirect user
      return; // skip the rest
    }
  
    // Regular test connection flow
    setTestLoading(true);
    setTestResult(null);
    try {
      const apiService = new ApiService(
        `${BASE_URL}/connector_configs/${configId}/test_connection`,
        { "Content-Type": "application/json" },
        "POST"
      );
      const response = await apiService.makeCall();
      setTestResult(response);
      message.success("Connection test completed");
    } catch (err) {
      console.error("Error testing connection:", err);
      message.error("Test connection failed");
      setTestResult({ error: err.message });
    } finally {
      setTestLoading(false);
    }
  };
  
  

  return (
    <Modal
  open={visible}
  title={
    // inside Modal title area
    <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center" }}>
      <span>Connector Config Details</span>
      <div style={{ display: "flex", gap: 8, alignItems: "center" }}>
        <Checkbox 
          checked={redirectChecked} 
          onChange={(e) => setRedirectChecked(e.target.checked)}
        >
          Redirect for Auth
        </Checkbox>
        <Button
          type="primary"
          onClick={handleTestConnection}
          loading={testLoading}
        >
          Test Connection
        </Button>
      </div>
    </div>

  }
  onCancel={onClose}
  footer={[
    <Button key="close" onClick={onClose}>
      Close
    </Button>,
  ]}
  width={800}
  bodyStyle={{ maxHeight: "70vh", overflowY: "auto" }}
>
  {loading ? (
    <Spin />
  ) : config ? (
    <>
      <Descriptions bordered column={1} size="middle">
        <Descriptions.Item label="Connector ID">
          {config.connector_id}
        </Descriptions.Item>
        <Descriptions.Item label="Base URL">
          {config.base_url}
        </Descriptions.Item>
        <Descriptions.Item label="Auth URL">
          {config.auth_url}
        </Descriptions.Item>
        <Descriptions.Item label="Method">
          {config.method}
        </Descriptions.Item>
        <Descriptions.Item label="Path">
          {config.path}
        </Descriptions.Item>
        <Descriptions.Item label="Auth Type">
          {config.auth_type}
        </Descriptions.Item>
        <Descriptions.Item label="Query Params Template">
          <pre style={{ whiteSpace: "pre-wrap" }}>
            {JSON.stringify(config.query_params_template, null, 2)}
          </pre>
        </Descriptions.Item>
        <Descriptions.Item label="Body Template">
          <pre style={{ whiteSpace: "pre-wrap" }}>
            {JSON.stringify(config.body_template, null, 2)}
          </pre>
        </Descriptions.Item>
        <Descriptions.Item label="Access Token Path">
          {config.access_token_path}
        </Descriptions.Item>
        <Descriptions.Item label="Rate Limit Config">
          <pre style={{ whiteSpace: "pre-wrap" }}>
            {JSON.stringify(config.rate_limit_config, null, 2)}
          </pre>
        </Descriptions.Item>
        <Descriptions.Item label="Retry Config">
          <pre style={{ whiteSpace: "pre-wrap" }}>
            {JSON.stringify(config.retry_config, null, 2)}
          </pre>
        </Descriptions.Item>
      </Descriptions>

      {testResult && (
        <div style={{ marginTop: 20 }}>
          <Title level={5}>Test Connection Output</Title>
          <pre style={{ background: "#f5f5f5", padding: 12, borderRadius: 6 }}>
            {JSON.stringify(testResult, null, 2)}
          </pre>
        </div>
      )}
    </>
  ) : (
    <p>No details found</p>
  )}
</Modal>

  );
};

export default CustomConnectorConfigDetail;
